import { useEffect } from 'react';
import Script from 'next/script';

export default function FCPTracker() {
    useEffect(() => {
        const observer = new PerformanceObserver((list) => {
            const entries = list.getEntries();
            const firstContentfulPaint = entries.find((entry) => entry.name === 'first-contentful-paint');

            if (firstContentfulPaint) {
                console.log('First Contentful Paint (FCP):', firstContentfulPaint.startTime);
                // You can perform further actions with the FCP value, such as sending it to an analytics service.
            }
        });

        // Observe the 'largest-contentful-paint' entry type
        observer.observe({ type: 'paint', buffered: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Script
            id="fcp-tracker"
            strategy="beforeInteractive"
            src="/empty.js"
        />
    );
}